export default {
  LandingPage: {
    intro_sub:
      "Offrez une seconde vie aux emballages et contribuez à la protection de l'environnement.",
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Ensemble, réduisons les déchets et préservons',
    sequence1_2:
      "l'environnement en construisant des objets utiles avec l'emballage de votre produit",
    sequence2_1:
      'Nous vous présentons le nouvel emballage Upcycle-Packaging de Samsung',
    sequence2_2:
      'Spécialement conçu pour être réutilisé, il vous permet de créer des objets pour votre maison. Ecologique et utile!',
    sequence3_1:
      "Des points imprimés sur l'emballage vous aident à découper facilement les différentes pièces",
    sequence3_2:
      "Vous n'avez plus qu'à les assembler pour obtenir l'objet souhaité",
    sequence4_1: "Vous n'avez plus qu'à choisir votre objet préféré",
    sequence4_2:
      "Scrollez vers le bas et sélectionnez l'emballage du produit que vous possédez. Choisissez le modèle que vous souhaitez créer et laissez parler votre créativité",
    selectBox: 'Sélectionnez votre produit',
    moreActivity:
      "Consultez plus d'informations sur les activités durables chez Samsung",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame',
    theSerif: 'The Serif',
    theSero: 'The Sero',
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet02:'Soundbar Set 2',
    SoundbarSet01:'Soundbar Set 1',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/fr/sustainability/overview/',
    //moreActivityLink:'https://www.samsung.com/fr/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/fr/sustainability/overview/',
    footer: 'Copyright© 2019 - 2021 SAMSUNG. Tous droits réservés.',
    //     <br/>
    // Ce sit,e est optimisé pour Internet Explorer 11, Chrome, Safari ainsi que pour les navigateurs plus récents.`
  },
  ProductPage: {
    selectDesign: 'Sélectionnez le design à créer',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'Console de télévision',
    StorageBox: 'Boîte de rangement',
    MagazineRack: 'Rangement de revue',
    CatHouse: 'Maison du chat',
    CatTunnel: 'Tunnel de chat',
    BookShelf: 'Étagère de livres',
    DeskShelf: 'Étagère du bureau',
    BlackRhino: 'Endangered \n Animals \n Black Rhino', //update
    PolarBear: 'Endangered \n Animals \n Polar Bear', //update
    SeaTurtle: 'Endangered \n Animals \n Sea Turtle', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko table', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postcard \n Planter', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Tool Box', //update
    DeskStationary: 'Papeterie',
    CoinBank: 'Tirelire',
    MobileScanner:'Support de scanner smartphone',
    TabletScanner:'Support de scanner de tablette',
    PetStairs:'Escaliers pour animaux de compagnie',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'Minute',
    all:'ALL',
    in: 'Pouce (Inch)',
    inOnly: 'Uniquement en pouce (inch)',
    allBoxSize: 'Toutes les tailles de boîte',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'Notices informative',
    prepare: 'Préparez la boîte',
    LetsDesign: 'Commencez le design',
    drawParts: 'Dessinez des pièces sur la boîte',
    note1:
      'Notez que la position graphique peut varier selon les pays et les tailles de la boîte',
    note2: "Esquissez d'abord le dessin entier pour qu'il tienne dans la boîte",
    numberSpace: 'Nombre = espaces entre les points',
    diagonal: 'Diagonal',
    LEFT: 'Côté gauche',
    RIGHT: 'Côté droit',
    TOP: 'Surface en haut',
    TOP1: 'Surface en haut 1',
    TOP2: 'Surface en haut 2',
    BACK: 'Dos',
    MIDDLE: 'Milieu',
    MIDDLE2: 'Milieu 2',
    BOTTOM: 'Bas',
    FRONT: 'Face',
    SIDE: 'Côté',
    secondSIDE: 'Deuxième côté',
    secondSIDE1: 'Deuxième côté 1',
    secondSIDE2: 'Deuxième côté 2',
    cutAndAssemble: 'Coupez les éléments et assemblez-les.',
    LEG: 'JAMBE', //update
    JOINT: 'JOINT', //update
    FACE: 'FACE', //update
    DRAWERBOTTOM: 'BAS DE TIROIR', //update
    DRAWERSIDE: 'CÔTÉ DE TIROIR', //update
    NOSE: 'NEZ', //update
    HANDLE: 'POINÉE', //update
    BOTTOMSIDE: 'CÔTÉ DU BAS', //update
    TOPSIDE: 'CÔTÉ DE LA PARTIE SUPÉRIEURE', //update
    WING: 'AILE', //update
    beCareful:
      "Attention à ne pas vous blesser lors de l'utilisation du cutter",
    cutOutParts: 'Découpez des pièces',
    assemble: 'Assemblez-les',
    Assemblyguide: 'Guide de montage', //update
    fold: 'Exemple de pliage',
    foldGuide: 'Utilisez le bord des meubles lorsque vous pliez le carton',
    foldGuideDezeen:
      'Appuyez plusieurs fois sur la ligne pointillée avec un outil de pliage pour aider le carton à se plier', //update
    glue: 'Appliquez de la colle ou du scotch uniformément sur la surface', //update
    cable: 'Utilisez des serre-câbles ou des cordes pour connecter', //update
    done: 'Terminé !',
    goBack: 'Revenir au menu principal',
  },
  CautionPage: {
    CAUTION: 'MISE EN GARDE',
    needItem: 'Vous aurez besoin des articles sur cette image',
    children: 'Les enfants doivent être sous la surveillance des adultes',
    mat:
      'Veuillez mettre un matelas sur le sol pour éviter les rayures du processus',
    doNotPutHeavyThing:
      "Il ne faut pas marcher ou s'assoir sur ces meubles, ni y mettre de choses lourdes",
    doNotThrow:
      'Il ne faut pas jeter ces meubles, ni donner des coups de pied aux meubles',
    stayAwayFlame: 'Il faut éloigner les meubles de la chaleur du feu',
    stayAwayWater: "Il faut éloigner les meubles de l'eau ou de l'humidité",
    mayDamaged:
      "* Le boîte du téléviseur peut être endommagé pendant le processus d'expédition",
    companyDoestResponsible:
      "* L'entreprise n'a aucune responsabilité en cas de pannes ou de bris causés pendant l’assemblage des meubles",
    cannotBeReturned:'',
    understand: "D'accord, j'ai compris",
  },
  PrivacyPolicy: {
    title: 'Politique de confidentialité',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        "Nous renforçons notre engagement en faveur du développement durable avec notre nouvel emballage.",
      text2:
        "Nous avons utilisé moins de papier et d'encre pour les emballages de télévision qui peuvent se transformer en articles ménagers.",
      text2_special:'',
      text3: 'Sélectionnez les boutons ci-dessous pour en savoir plus.',
    },
    greenIn: {
      title: `Passer au vert dans l'emballage de la télévision`,
      subtitle1: 'Informations sur le produit sans encre',
      subtitle2: `Eco-emballage pour Surcyclage`,
      desc: `Recherchez le nom du modèle pour obtenir plus d'informations`,
      descM: '*Take a photo of the TV model number',
      guide: `nom du modèle`,
      button: 'Take Photo',
      button2: `Aller à assembler des articles`,
    },
    search: {
      guide: 'Search..',
      noResult: 'Pas de résultat',
      more: `S'informer en plus`,
    },
  },
  searchCountrySelect: 'Sélectionnez un pays à rechercher'
};
